module.exports = __webpack_public_path__ + "img/visual-manage.c5945047.png";